import React, { useEffect, useState } from "react";
import ReactStrapTable from "components/reactStrapTable";
import { cellRendererCheck } from "utils/columns";
import {
  Card,
  CardBody,
  CardTitle,
  Col,
  Row,
  CardHeader,
  Nav,
  NavItem,
  Button,
} from "reactstrap";
import ErrorBoundary from "components/ErrorBoundary";
import Top20RebatableDrugDrawer from "pages/ClientDashBoard/Components/GridData/GridReports/Top20RebatableDrugsDrawer";
import Drawer from "components/Drawer";
const Top20RebatableDrugs = ({ top20Rebate, dateRange, planId, groupId, startDate,endDate ,rebatechecked }) => {
  const [summaryData, setSummaryData] = useState([]);
  const [disabledViewButtom, setDisabledViewButtom] = useState(true);
     const [isOpen, setIsOpen] = useState(false);
     useEffect(() => {
   if (Array.isArray(top20Rebate) && top20Rebate.length > 0)
     { 
      setDisabledViewButtom(false);
      }
       else { 
        setDisabledViewButtom(true);
       }
       }, [top20Rebate]);
  const handleProceed = () => {
    setIsOpen(!isOpen);
  };
  const currencyFormat = (value) => {
    if (!value || isNaN(value)) return "-";
    if (value < 0)
      return (
        <span className="text-danger text-end">
          {"-$" +
            (value * -1).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}
        </span>
      );
    else
      return (
        <span className="text-end">
          {"$" + value.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}
        </span>
      );
  };
  const Top20RelatableDrugsColumns = [
    {
      dataField: "drugName",
      text: "Drug Name",
      sort: false,
      width: 140,
      show: true,
      inputType: "text",
      hideColFilter: true,
      cellRenderer: (top20Rebate) => cellRendererCheck(top20Rebate.drugName),
    },
    {
      dataField: "rebateDollersReceived",
      text: "Rebate Dollars Received",
      sort: false,
      width: 140,
      show: true,
      inputType: "text",
      hideColFilter: true,
      cellRenderer: (top20Rebate) =>
        currencyFormat(top20Rebate.rebateDollersReceived),
    },
    {
      dataField: "preRebatePlanSpend",
      text: "Pre Rebate Plan Spend",
      sort: false,
      width: 140,
      show: true,
      inputType: "text",
      hideColFilter: true,
      cellRenderer: (top20Rebate) =>
        currencyFormat(top20Rebate.preRebatePlanSpend),
    },
    {
      dataField: "postRebatePlanTotalSpend",
      text: "Post Rebate Plan Spend",
      sort: false,
      width: 140,
      show: true,
      inputType: "text",
      hideColFilter: true,
      cellRenderer: (top20Rebate) =>
        currencyFormat(top20Rebate.postRebatePlanTotalSpend),
    },
  ];
   const onHandleIsOpen = (hasRefresh)=> {
      
        if (isBoolean(hasRefresh) && hasRefresh) {
            onClose(true);
        }
        setIsOpen(!isOpen)
      }


  return (
    <ErrorBoundary>
    <Card className="p-3 h-100">
      <CardHeader className="border-0 bg-white px-0 pt-0">
        <Row className="align-items-center">
          <Col>
            <CardTitle className="f-20 font-weight-500">
              Top 20 Rebatable Drugs
            </CardTitle>
          </Col>
        </Row>
      </CardHeader>

      <CardBody className="dashboard-chart-body">
        <div
          className={`table-card scroll-table position-relative border-0 rounded pt-0 scroll ${
            Array.isArray(top20Rebate) && top20Rebate.length > 0
              ? "fixed-height"
              : ""
          }`}
        >
          <ReactStrapTable
            columns={Top20RelatableDrugsColumns}
            data={top20Rebate}
          />
        </div>
        <div className="view-report">
          <Button
            color="primary"
            className="ms-2"
            onClick={handleProceed}
            style={{ float: "right", marginTop: "26px" }}
            disabled={disabledViewButtom}
          >
            View Report
          </Button>
        </div>
      </CardBody>
    </Card>
     <Drawer
                    direction='end'
                    title='Top 20 Rebatable Drugs'
                    isOpen={isOpen}
                    toggle={handleProceed}
                    size="lg"
                       disabled={disabledViewButtom}
                            
                >
    <Top20RebatableDrugDrawer dateRange={dateRange} planId={planId} groupId={groupId} startDate={startDate} endDate={endDate} rebatechecked={rebatechecked} onHandleIsOpen={onHandleIsOpen}  />
                </Drawer> 
    </ErrorBoundary>
  );
};

export default Top20RebatableDrugs;
